import { SortPartSerializer1fx0t5bmnpc8h as SortPartSerializer } from './SortPartSerializer.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_compare1s08igku0oz25 as get_compare } from '../serialization/DataClassPath.sort.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { compareTo27a9ghv6nck15 as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (SortPartSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SortPartClass;
function SortPart() {
  if (SortPartClass === VOID) {
    class $ {
      constructor(field, ascending, ignoreCase) {
        ascending = ascending === VOID ? true : ascending;
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        this.n4a_1 = field;
        this.o4a_1 = ascending;
        this.p4a_1 = ignoreCase;
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().d1();
        if (!this.o4a_1) {
          this_0.xb(_Char___init__impl__6a9atx(45));
        }
        if (this.p4a_1) {
          this_0.xb(_Char___init__impl__6a9atx(126));
        }
        this_0.wb(this.n4a_1.toString());
        return this_0.toString();
      }
      hashCode() {
        var result = this.n4a_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.o4a_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.p4a_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SortPart()))
          return false;
        if (!this.n4a_1.equals(other.n4a_1))
          return false;
        if (!(this.o4a_1 === other.o4a_1))
          return false;
        if (!(this.p4a_1 === other.p4a_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SortPart', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    SortPartClass = $;
  }
  return SortPartClass;
}
function get_comparator(_this__u8e3s4) {
  if (_this__u8e3s4.i1())
    return null;
  var tmp = (a, b) => {
    var _iterator__ex2g4s = _this__u8e3s4.m1();
    while (_iterator__ex2g4s.n1()) {
      var part = _iterator__ex2g4s.o1();
      if (part.p4a_1 && equals(part.n4a_1.r4a().az().s11(), STRING_getInstance())) {
        var tmp = part.n4a_1.q4a(a);
        var aString = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
        var tmp_0 = part.n4a_1.q4a(b);
        var bString = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
        var result = compareTo(aString, bString, true);
        if (!(result === 0))
          return part.o4a_1 ? result : -result | 0;
      } else {
        var result_0 = get_compare(part.n4a_1).compare(a, b);
        if (!(result_0 === 0))
          return part.o4a_1 ? result_0 : -result_0 | 0;
      }
    }
    return 0;
  };
  return new (sam$kotlin_Comparator$0())(tmp);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.s4a_1 = function_0;
      }
      wi(a, b) {
        return this.s4a_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.s4a_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  SortPart as SortPart1gsioxz0aa07v,
  get_comparator as get_comparator3ku3zoggvro4l,
  Companion_instance as Companion_instance1wlwjbzvod7vj,
};
//endregion

//# sourceMappingURL=SortPart.mjs.map
